const TYPE = 'ROCKY';

export const START_ROCKY_EXPERIMENT = `${TYPE}/START_ROCKY_EXPERIMENT`;